import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExpandableToFullHeight } from "@faire/retailer-visitor-shared/components/ExpandableToFullHeight/ExpandableToFullHeight";
import { FilterInfoSticky } from "@faire/retailer-visitor-shared/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { MAX_WIDE_SCREEN_CONTENT_WIDTH } from "@faire/retailer-visitor-shared/features/Marketplace/styleConsts";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { OuterResultsContentWrapper } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/CategoryPageCommonStyles";
import { CategoryNextPagePrefetch } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/CategoryNextPagePrefetch";
import { CategoryPageSidebar } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/CategoryPageSidebar";
import { useIsCategoryPageFiltersLoading } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageFiltersLoading";
import { CategoryPageLayoutElements } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/CategoryPageLayoutElements";
import { useGetCategoryPageLayoutElementsByPlacement } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/useGetCategoryPageLayoutElementsByPlacement";
import { CategoryPageFilters } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/FiltersAndContent/__internal__/CategoryPageFilters";
import { CategoryPageFilterStoreProvider } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/FiltersAndContent/__internal__/CategoryPageFilterStoreProvider";
import { Title } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/FiltersAndContent/__internal__/Title";
import { useCategoryPageHeaderAndSubheaderTexts } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/HeaderAndSubheader/useCategoryPageHeaderAndSubheaderTexts";
import { CategoryPagePagination } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/Pagination/CategoryPagePagination";
import { CategoryPageProductOrBrandGrid } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/ProductOrBrandGrid/CategoryPageProductOrBrandGrid";
import { CategoryPageRetrievalQueries } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/__internal__/RetrievalQueries/CategoryPageRetrievalQueries";
import { useIsBestsellers } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsBestsellers";
import { useIsFullWidthCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsFullWidthCategory";
import { useIsHubCategoryLoadingStrategy } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useIsHubCategoryLoadingStrategy";
import { useCurrentNavigationPath } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentNavigationPath";
import { ElevatedContentWrapper } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackCategoriesPaginationClick } from "@faire/web-api--source/events/categories/click/pagination";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import React, { useState } from "react";
import styled, { css } from "styled-components";
var Placement = ILayoutElement.Placement;
export var CategoryPageFiltersAndContent = function(param) {
    var scrollToTop = param.scrollToTop, scrollRef = param.scrollRef, pageLoadTimingRef = param.pageLoadTimingRef, className = param.className;
    var _layoutElementsBelowBreadcrumb_, _layoutElementsBelowBreadcrumb_1;
    var isFiltersLoading = useIsCategoryPageFiltersLoading();
    var useHubUPLTMeasurement = useIsHubCategoryLoadingStrategy();
    var navigationPath = useCurrentNavigationPath();
    var getCategoryPageLayoutElementsByPlacement = useGetCategoryPageLayoutElementsByPlacement();
    var layoutElementsBelowBreadcrumb = getCategoryPageLayoutElementsByPlacement(Placement.BELOW_BREADCRUMB);
    var hasFullWidthBannerBelowBreadcrumb = ((_layoutElementsBelowBreadcrumb_ = layoutElementsBelowBreadcrumb[0]) === null || _layoutElementsBelowBreadcrumb_ === void 0 ? void 0 : _layoutElementsBelowBreadcrumb_.type) === ILayoutElement.Type.FULL_WIDTH_IMAGE_BANNER || ((_layoutElementsBelowBreadcrumb_1 = layoutElementsBelowBreadcrumb[0]) === null || _layoutElementsBelowBreadcrumb_1 === void 0 ? void 0 : _layoutElementsBelowBreadcrumb_1.type) === ILayoutElement.Type.MID_PRICE_POINT_PLUS_CATEGORY_HOME_PAGE_HEADER_BANNER;
    var shouldShowContentTopPadding = !layoutElementsBelowBreadcrumb.some(function(element) {
        return element.type !== ILayoutElement.Type.NO_OP_LAYOUT_ELEMENT;
    });
    var _useCategoryPageHeaderAndSubheaderTexts = useCategoryPageHeaderAndSubheaderTexts(), headerText = _useCategoryPageHeaderAndSubheaderTexts.headerText, subheaderText = _useCategoryPageHeaderAndSubheaderTexts.subheaderText, gridHeaderText = _useCategoryPageHeaderAndSubheaderTexts.gridHeaderText;
    var isFullWidthCategory = useIsFullWidthCategory();
    var _useIsBestsellers = useIsBestsellers(), isBestsellers = _useIsBestsellers.isBestsellers, isBestsellersProductCategory = _useIsBestsellers.isBestsellersProductCategory;
    var shouldShowTopPageTitle = layoutElementsBelowBreadcrumb.length > 0 && !hasFullWidthBannerBelowBreadcrumb && isFullWidthCategory;
    var _useState = _sliced_to_array(useState(false), 2), isScrollingToTop = _useState[0], setIsScrollingToTop = _useState[1];
    return /*#__PURE__*/ _jsxs(CategoryPageFilterStoreProvider, {
        children: [
            shouldShowTopPageTitle ? /*#__PURE__*/ _jsx(PageTitleRow, {
                children: /*#__PURE__*/ _jsx(Title, {
                    titleVariant: "pageHeaderSerifRegular",
                    title: headerText,
                    subtitle: subheaderText
                })
            }) : null,
            /*#__PURE__*/ _jsx(CategoryPageLayoutElements, {
                placement: ILayoutElement.Placement.BELOW_BREADCRUMB,
                hubCategoryPageLoadTimingRef: useHubUPLTMeasurement ? pageLoadTimingRef : undefined
            }),
            isBestsellers && !isBestsellersProductCategory && layoutElementsBelowBreadcrumb.length > 0 ? /*#__PURE__*/ _jsx(Spacer, {
                size: "6x"
            }) : null,
            /*#__PURE__*/ _jsxs(ElevatedContentWrapper, {
                $maxWidth: isFullWidthCategory ? MAX_WIDE_SCREEN_CONTENT_WIDTH : undefined,
                children: [
                    /*#__PURE__*/ _jsxs(ContentContainer, {
                        $includeTopPadding: shouldShowContentTopPadding,
                        children: [
                            /*#__PURE__*/ _jsxs(SidebarContainerWithFilters, {
                                children: [
                                    /*#__PURE__*/ _jsx(ExpandableToFullHeight, {
                                        children: /*#__PURE__*/ _jsx(CategoryPageSidebar, {})
                                    }),
                                    /*#__PURE__*/ _jsx(CategoryPageFilters, {})
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(StyledOuterResultsContentWrapper, {
                                ref: scrollRef,
                                className: className,
                                $omitRightPadding: isFullWidthCategory,
                                children: [
                                    /*#__PURE__*/ _jsx(CategoryPageLayoutElements, {
                                        placement: ILayoutElement.Placement.ABOVE_TITLE,
                                        hubCategoryPageLoadTimingRef: useHubUPLTMeasurement ? pageLoadTimingRef : undefined
                                    }),
                                    /*#__PURE__*/ _jsx(HeaderRow, {
                                        children: /*#__PURE__*/ _jsx(StyledTitle, {
                                            titleVariant: "pageHeaderSerifRegular",
                                            title: gridHeaderText !== null && gridHeaderText !== void 0 ? gridHeaderText : headerText,
                                            subtitle: subheaderText,
                                            shouldHideTextTag: shouldShowTopPageTitle
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(CategoryPageLayoutElements, {
                                        placement: ILayoutElement.Placement.BELOW_TITLE,
                                        hubCategoryPageLoadTimingRef: useHubUPLTMeasurement ? pageLoadTimingRef : undefined
                                    }),
                                    /*#__PURE__*/ _jsx(StyledFilterInfoSticky, {
                                        name: FilterName.LOGGED_IN_CATEGORY,
                                        isLoading: isFiltersLoading,
                                        shouldShowSort: true,
                                        shouldEnableScrollToProducts: true
                                    }),
                                    /*#__PURE__*/ _jsx(CategoryPageRetrievalQueries, {}),
                                    /*#__PURE__*/ _jsx(CategoryPageProductOrBrandGrid, {
                                        categoryPageLoadTimingRef: useHubUPLTMeasurement ? undefined : pageLoadTimingRef,
                                        isScrollingToTop: isScrollingToTop,
                                        onFirstBatchVisible: function() {
                                            return setIsScrollingToTop(false);
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ContentContainer, {
                        children: /*#__PURE__*/ _jsxs(StyledOuterResultsContentWrapper, {
                            $omitRightPadding: isFullWidthCategory,
                            style: {
                                minHeight: 0,
                                paddingBottom: 0
                            },
                            children: [
                                /*#__PURE__*/ _jsx(CategoryNextPagePrefetch, {}),
                                /*#__PURE__*/ _jsxs(WhenVisibilityIsImminent, {
                                    children: [
                                        /*#__PURE__*/ _jsx(CategoryPagePagination, {
                                            onChangePage: function(page) {
                                                trackCategoriesPaginationClick(navigationPath, page.toString());
                                                setIsScrollingToTop(true);
                                                setTimeoutIfPossible(function() {
                                                    setIsScrollingToTop(false);
                                                }, 1000);
                                                scrollToTop({
                                                    toResults: false,
                                                    toTop: page === 1
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(CategoryPageLayoutElements, {
                                            placement: ILayoutElement.Placement.ABOVE_FOOTER
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var HeaderRow = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-9dd842a7-0"
})([
    "padding-bottom:",
    ";"
], getSpacing("1x"));
// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
var SidebarContainerWithFilters = styled(Column).withConfig({
    componentId: "sc-9dd842a7-1"
})([
    "flex:0 0 228px;margin-right:",
    ";&&&{",
    "{display:none;}}"
], getSpacing("6x"), responsiveMediaQueries.tabletAndBelow);
var ContentContainer = styled(Row).withConfig({
    componentId: "sc-9dd842a7-2"
})([
    "height:100%;",
    ""
], function(param) {
    var $includeTopPadding = param.$includeTopPadding;
    return $includeTopPadding ? css([
        "padding-top:",
        ";"
    ], getSpacing("1x")) : "";
});
var StyledTitle = styled(Title).withConfig({
    componentId: "sc-9dd842a7-3"
})([
    "padding-top:2px;"
]);
var StyledFilterInfoSticky = styled(FilterInfoSticky).withConfig({
    componentId: "sc-9dd842a7-4"
})([
    "",
    "{width:unset;}"
], responsiveMediaQueries.tabletAndBelow);
var StyledOuterResultsContentWrapper = styled(OuterResultsContentWrapper).withConfig({
    componentId: "sc-9dd842a7-5"
})([
    "",
    ""
], function(param) {
    var $omitRightPadding = param.$omitRightPadding;
    return $omitRightPadding ? css([
        "&&&{",
        "{padding-right:0;}}"
    ], responsiveMediaQueries.desktopAndAbove) : "";
});
var PageTitleRow = styled(Row).withConfig({
    componentId: "sc-9dd842a7-6"
})([
    "&&&{width:100%;max-width:",
    "px;margin:auto;",
    "{padding:",
    " ",
    " 0px;}",
    "{padding:",
    " ",
    " 0px;}}"
], MAX_WIDE_SCREEN_CONTENT_WIDTH, responsiveMediaQueries.mobile, getSpacing("2x"), getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, getSpacing("3x"), getSpacing("6x"));
